/*eslint-disable*/
import React from "react";

/**
 * Pie del layout de acceso. Ancho fijo de 1310px fuera y ahora simplemente se
 * adapta a su columna.
 */
export default function Footer() {
  return (
    <div className="select-none px-6 pb-6 md:px-10">
      <p className="text-[12px] text-gray-700 dark:text-gray-500">
        © {new Date().getFullYear()} TF. Todos los derechos reservados.
      </p>
    </div>
  );
}
